/**
 * @desc 编辑费用请款
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.CostRequestUpdateDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/updateCostRequest`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
